import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import {RecordlogEvents} from '../../analytics/RecordEvents'
import { useSelector } from 'react-redux';
const PartnersCard = ({ data }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const userdata = useSelector((state) => state?.userdata?.value?.rnuserdetails);
  const handlePartner = (e) => {
    try{nojoomProductViewed(data?.category)}catch{}
    e.preventDefault();
    navigate(`/nojoom-partner/${data?.id}`);
  };
  console.log('PartnersCard_data', data);

  const nojoomProductViewed = (_itemName) => {
      try {
        RecordlogEvents('Nojoom Product Viewed', {
          'Mobile Number': userdata?.msisdn,
          'Product Viewed': _itemName,
          Status: "Success",
          'Status Description': "Success",
          'Login Type': logintype,
        });
      } catch (e) {
      }
  };


  return (
    <Link className="card_style_1 height_100" to={`#`} onClick={handlePartner}>
      <div className="card_img">
        <img
          src={
            data?.categoryimage || data?.image ||
            process.env.PUBLIC_URL + '/assets/images/dummy_img.jpg'
          }
          alt=""
          title=""
        />
      </div>
      <div className="card_info text-center">
        <div className="card_info_grp">
          <h4 className="text-ellipsis">{data?.category}</h4>
        </div>
        <div className="card_link">
          <Link to="#" className="hyperlink" onClick={handlePartner}>
            {t('EXPLORE')}
            <img
              src={
                process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
              }
              alt=""
              title=""
            />
          </Link>
        </div>
      </div>
    </Link>
  );
};
export default PartnersCard;
